import { notifyActionTypes } from './notify.types';

export const showNotify = ({ message }) => ({
    type: notifyActionTypes.SHOW_NOTIFY,
    payload: { message },
});

export const hideNotify = () => ({
    type: notifyActionTypes.HIDE_NOTIFY,
});
